import React, { Component } from "react";
import { Link } from "react-router-dom";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetTakeOffCsvDTO from "../../../models/DTO/IGetTakeOffCsvDTO";
import IGetTakeOffsDTO from "../../../models/DTO/IGetTakeOffsDTO";
import IOnGetTakeOffCsvDTO from "../../../models/DTO/IOnGetTakeOffCsvDTO";
import IOnGetTakeOffsDTO from "../../../models/DTO/IOnGetTakeOffsDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import IOwTableCols from "../../../models/IOwTableCols";
import ISupplierModel from "../../../models/ISupplierModel";
import ITake_Off from "../../../models/ITake_Off";
import IUserUI from "../../../models/IUserUI";
import UserService from "../../../services/UserService";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwButton from "../../shared/OwButton/OwButton";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import TakeOffDetailSidebar from "../TakeOffDetailSidebar/TakeOffDetailSidebar";
import TakeOffSidebar from "../TakeOffSidebar/TakeOffSidebar";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
};

type State = {
    crumbs: IBreadcrumbs[];
    columns: IOwTableCols[];
    detailViewCols: IOwTableCols[];
    takeOffs: any[];
    totalTakeOffs: number;
    isDataFetching: boolean;
    initialData: boolean;
    limit: number;
    offset: number;
};

class TakeOffs extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        const detailViewCols: IOwTableCols[] = [
            {
                title: "",
                valueProp: "",
                isActionsCol: true,
                renderFnEmitsRow: true,
                renderFn: this.renderDetailActionColFn,
            },
            {
                title: "no",
                valueProp: "name",
            },
            {
                title: "description",
                valueProp: "description",
            },
            {
                title: "status",
                valueProp: "Order_State",
                valueSubProp: "name",
            },
            {
                title: "updated_at",
                valueProp: "updated_at",
                renderFn: this.renderUpdatedAt,
            },
        ];

        this.state = {
            crumbs: [
                { title: "dashboard", url: "/dashboard" },
                { title: "take_offs", url: "/take_offs" },
            ],
            columns: [
                {
                    title: "",
                    valueProp: "",
                    renderFn: this.renderActionsColFn,
                    renderFnEmitsRow: true,
                    hasChevron: true,
                    isActionsCol: true,
                },
                {
                    title: "project",
                    valueProp: "Project",
                    valueSubProp: "name",
                },
                {
                    title: "vendor",
                    valueProp: "Vendor",
                    valueSubProp: "name",
                    isVendorOverride: true,
                },
                {
                    title: "updated_at",
                    valueProp: "updated_at",
                    renderFn: this.renderUpdatedAt,
                },
            ],
            detailViewCols,
            takeOffs: [],
            totalTakeOffs: 0,
            isDataFetching: false,
            initialData: true,
            limit: 25,
            offset: 0,
        };

        document.title = "Orderwerks >> Take Offs";
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.TakeOffOnGetTakeOffs, this.onGetTakeOffs);

        this.getTakeOffs();
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.TakeOffOnGetTakeOffs, this.onGetTakeOffs);
    }

    renderDetailActionColFn = (row: any) => {
        return (
            <div>
                <Link to={`/take_offs/${row.guid}`}>
                    <i className={"fad fa-eye"} />
                </Link>
            </div>
        );
    };

    renderActionsColFn = (data: any) => {
        return (
            <div>
                {/*<i className={"fad fa-trash-alt text-danger pointer me-4"} />*/}
                {/*<i className={"fad fa-pencil text-primary pointer me-2"} />*/}
            </div>
        );
    };

    renderUpdatedAt = (dateStr: string) => {
        return UserService.parseDate(dateStr);
    };

    getTakeOffs = (queryString?: string) => {
        const payload: IGetTakeOffsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.TakeOffGetTakeOffs, payload);

        this.setState({
            isDataFetching: true,
        });
    };

    onGetTakeOffs = (data: IOnGetTakeOffsDTO) => {
        this.setState({
            totalTakeOffs: data.totalTakeOffs,
            takeOffs: data.takeOffs,
            isDataFetching: false,
            initialData: false,
        });
    };

    addTakeOff = (takeoff?: any) => {
        const component = (
            <TakeOffSidebar
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                setActivityIndicator={this.props.setActivityIndicator}
                notifyFn={this.props.notifyFn}
                socket={this.props.socket}
                cancelFn={this.closeSidebar}
            />
        );

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    closeSidebar = () => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);

        this.getTakeOffs();
    };

    performSearch = () => {
        let queryString;
        // assemble the query string

        this.getTakeOffs(queryString);
    };

    onPaginationChanged = (limit: number, offset: number) => {
        this.setState(
            {
                limit,
                offset,
            },
            () => {
                this.performSearch();
            }
        );
    };

    addTakeOffDetail = (row: ITake_Off) => {
        // create a new detail take off for the given row.
        const component = (
            <TakeOffDetailSidebar
                cancelFn={this.closeSidebar}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                setActivityIndicator={this.props.setActivityIndicator}
                supplierModel={this.props.supplierModel}
                userModel={this.props.userModel}
                takeOff={row}
            />
        );

        this.props.setSidebarComponent(component);

        this.props.toggleSidebar(true);
    };

    renderTakeOffDetailView = (row: ITake_Off, index: number) => {
        return (
            <div>
                <div className={"mb-2"}>
                    <OwButton
                        title={"add"}
                        leftIconClass={"fas fa-plus"}
                        fn={() => {
                            this.addTakeOffDetail(row);
                        }}
                    />
                </div>

                <div>
                    <OwTable
                        columns={this.state.detailViewCols}
                        dataSet={row.Take_Offs || []}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={false}
                        initialData={false}
                    />
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="TakeOffs">
                {/*<Breadcrumbs crumbs={this.state.crumbs} />*/}

                <div className="row mt-2">
                    <div className="col-12 d-flex align-items-center justify-items-center">
                        <OwTitle title={"take_offs"} leftIconName={"fad fa-table"} className={"me-2"} />
                        <OwButton title={"add"} leftIconClass={"fas fa-plus"} fn={this.addTakeOff} />
                    </div>
                </div>

                <div className={"d-flex mb-3 mt-3"}></div>

                <div>
                    <OwTable
                        columns={this.state.columns}
                        dataSet={this.state.takeOffs}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.isDataFetching}
                        initialData={this.state.initialData}
                        rowDetailViewFn={() => {
                            return true;
                        }}
                        tableConfig={{ hasDetailView: true }}
                        detailViewComponent={this.renderTakeOffDetailView}
                    />
                </div>

                <div>
                    <PaginationBar
                        offset={this.state.offset}
                        limit={this.state.limit}
                        totalRecords={this.state.totalTakeOffs}
                        onPaginationChanged={this.onPaginationChanged}
                    />
                </div>
            </div>
        );
    }
}

export default TakeOffs;
